module.exports = __webpack_public_path__ + "img/temp_w.15246917.svg";